@if (protectionPlanGroups.length > 0) {
@for (group of protectionPlanGroups; track group.type) {
<h3 class="m-t m-b"
    [sizeClass]="'SM: s1, XL: s2'">{{getHeaderForType(group.type)}}</h3>
@for (product of group.products; track product.id) {
<protection-plans-item [product]="product" />
}
}
}